// PROTOTYPE
import { UploadOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { PrototypeBadge } from '../../../Prototype';
import styles from '../../lexical-editor.module.css';
import { VIDEO_UPLOAD_ACCEPT } from '../../videoEmbed';
import type { ToolbarVideoController } from './types';

const { Text } = Typography;

interface VideoUploadTabProps {
  video: ToolbarVideoController;
}

export function VideoUploadTab({ video }: VideoUploadTabProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.videoTabBody}>
      <PrototypeBadge description={t('exp_video_upload_prototype_notice')} />
      <Text type="secondary">{t('exp_video_upload_help')}</Text>
      <input
        ref={video.fileInputRef}
        accept={VIDEO_UPLOAD_ACCEPT}
        className={styles.imageFileInput}
        data-testid="videoUploadFileInput"
        onChange={video.handleFileChange}
        type="file"
      />
      <div className={styles.videoUploadActions}>
        <Button
          data-testid="videoUploadButton"
          icon={<UploadOutlined />}
          onClick={() => {
            video.fileInputRef.current?.click();
          }}
          type="primary"
        >
          {t('exp_video_upload_button')}
        </Button>
      </div>
      {!!video.uploadError && (
        <div className={styles.imageUploadError} data-testid="videoUploadError">
          {t(
            video.uploadError === 'size'
              ? 'exp_video_upload_error_size'
              : 'exp_video_upload_error_format'
          )}
        </div>
      )}
    </div>
  );
}
